export const SUB_DIR = {
    LOGIN: 'login',
    UNSUBSCRIBE: 'unsubscribe',
    SESSION_EXPIRED: 'session-expired',
    COVER_NOTE: 'cover-note',
    POLICY: 'policy',
    ARCHIVED: 'archived',
    ENQUIRY: 'enquiry',
    COMPANIES: 'companies',
    NORMAL_USERS: 'users',
    API_USERS: 'api-users',
    SETTINGS: 'settings'
};

export const URL = {
    LOGIN: `/ui/${SUB_DIR.LOGIN}`,
    SESSION_EXPIRED: `/ui/${SUB_DIR.SESSION_EXPIRED}`,
    UNSUBSCRIBE: `/ui/${SUB_DIR.UNSUBSCRIBE}`,
    SET_PASSWORD: '/ui/set-password/:id',
    RESET_PASSWORD: '/ui/reset-password/:id',
    FORGOT_PASSWORD: '/ui/forgot-password',
    DASHBOARD: '/ui/dashboard',
    CREATE: '/ui/create',
    COVER_NOTE: `/ui/${SUB_DIR.COVER_NOTE}`,
    VIEW_COVER_NOTE: `/ui/${SUB_DIR.COVER_NOTE}/:id`,
    POLICY: `/ui/${SUB_DIR.POLICY}`,
    VIEW_POLICY: `/ui/${SUB_DIR.POLICY}/:id`,
    ARCHIVED: `/ui/${SUB_DIR.ARCHIVED}`,
    VIEW_ARCHIVED_COVER_NOTE: `/ui/${SUB_DIR.ARCHIVED}/${SUB_DIR.COVER_NOTE}/:id`,
    VIEW_ARCHIVED_POLICY: `/ui/${SUB_DIR.ARCHIVED}/${SUB_DIR.POLICY}/:id`,
    BATCH: '/ui/batch',
    SEARCH: '/ui/search',
    ENQUIRY: `/ui/${SUB_DIR.ENQUIRY}`,
    SETTINGS: `/ui/${SUB_DIR.SETTINGS}`,
    COMPANIES: `/ui/${SUB_DIR.COMPANIES}`,
    NORMAL_USERS: `/ui/${SUB_DIR.NORMAL_USERS}`,
    API_USERS: `/ui/${SUB_DIR.API_USERS}`,
    SECRET: '/ui/secret/:id'
};

export const CUSTOM_ERROR = {
    ERROR_EVENT_NAME: 'CUSTOM_ERROR',
    CLEAR_ERROR_EVENT_NAME: 'CLEAR_CUSTOM_ERROR'
};

export const USER_ROLE = {
    SUBAGENT: 'SUBAGENT',
    INSURER: 'INSURER'
};

export const CONTENT_TYPE = {
    DASHBOARD: 'DASHBOARD',
    CREATE: 'CREATE',
    COVER_NOTE: 'COVER_NOTE',
    VIEW_COVER_NOTE: 'VIEW_COVER_NOTE',
    UPDATE_COVER_NOTE: 'UPDATE_COVER_NOTE',
    POLICY: 'POLICY',
    VIEW_POLICY: 'VIEW_POLICY',
    ARCHIVED: 'ARCHIVED',
    VIEW_ARCHIVED_COVER_NOTE: 'VIEW_ARCHIVED_COVER_NOTE',
    VIEW_ARCHIVED_POLICY: 'VIEW_ARCHIVED_POLICY',
    BATCH: 'BATCH',
    SEARCH: 'SEARCH',
    SETTINGS: 'SETTINGS',
    COMPANIES: 'COMPANIES',
    NORMAL_USERS: 'NORMAL_USERS',
    API_USERS: 'API_USERS'
};

export const PAGE_TYPE = {
    COVER_NOTE: 'COVER_NOTE',
    POLICY: 'POLICY',
    ARCHIVED: 'ARCHIVED',
    SEARCH: 'SEARCH',
    SETTINGS: 'SETTINGS'
};

export const FORM_ACTION_TYPE = {
    CREATE: 'CREATE',
    BATCH: 'BATCH'
};

export const POLICY_TYPE = {
    COVER_NOTE: 'coverNote',
    POLICY: 'policy',
    ARCHIVED: 'ARCHIVED',
};

export const FORM_TYPE = {
    IN_VIEW_COVER_NOTE: 'IN_VIEW_COVER_NOTE',
    SA_VIEW_POLICY: 'SA_VIEW_POLICY',
    IN_VIEW_POLICY: 'IN_VIEW_POLICY',
    SA_CREATE_COVER_NOTE: 'SA_CREATE_COVER_NOTE',
    IN_CREATE_COVER_NOTE: 'IN_CREATE_COVER_NOTE',
    IN_CREATE_POLICY: 'IN_CREATE_POLICY',
    IN_CONVERT_TO_POLICY: 'IN_CONVERT_TO_POLICY',
    UPDATE_COVER_NOTE: 'UPDATE_COVER_NOTE',
    UPDATE_POLICY: 'UPDATE_POLICY',
    VOID: 'VOID',
};

export const CREATE_FORM_STAGE = {
    CREATE: 'CREATE',
    CONFIRM_CREATE: 'CONFIRM_CREATE',
    CREATE_CN_SUMMARY: 'CREATE_CN_SUMMARY',
    CREATE_PY_SUMMARY: 'CREATE_PY_SUMMARY'
};

export const UPDATE_FORM_STAGE = {
    UPDATE: 'UPDATE',
    CONFIRM_VOID: 'CONFIRM_VOID',
    CONFIRM_UPDATE: 'CONFIRM_UPDATE',
    UPDATE_SUMMARY: 'UPDATE_SUMMARY',
};

export const VERIFY_FORM_STAGE = {
    APPROVE_CN: 'APPROVE_CN',
    ISSUE_POLICY: 'ISSUE_POLICY',
    CONVERT_TO_POLICY: 'CONVERT_TO_POLICY'
};

export const COMMON_FORM_STAGE = {
    PROCEED: 'PROCEED',
    PRINT: 'PRINT'
};

export const FLOW_STATUS = {
    RECEIVED: 'RECEIVED',
    CREATED: 'CREATED',
    CONFIRMED: 'CONFIRMED',
    INSURED: 'INSURED',
    VOIDED: 'VOIDED'
};

export const TABLE_TYPE = {
    INSURANCE: 'INSURANCE',
    ACTION: 'ACTION'
};

export const BATCH_STAGE = {
    READY: 'READY',
    CHECK: 'CHECK',
    VALID: 'VALID',
    INVALID: 'INVALID',
    SUBMIT: 'SUBMIT'
};

export const BATCH_ERROR_MESSAGES = {
    CSV_DUPLICATED: 'Please remove the duplicate record and upload again.',
    DLT_DUPLICATED: 'The record has already been uploaded to MIDAS, please remove the duplicate record and upload again.'
};

export const INVALID_RECORD_TYPE = {
    CSV_DUPLICATED: 'Duplicate record found.',
    DLT_DUPLICATED: 'Duplicated record found in DLT.'
};

export const RECORDS_SORT_BY = {
    DAY_LEFT: 'DAY_LEFT',
    ISSUE_NO: 'policyReference',
    COMPANY: 'subAgentCode',
    LICENSE: 'licensePlateNumber',
    END_DATE: 'policyEndDate',
    LAST_MODIFIED: 'lastModifiedDate'
};

export const COMPANIES_SORT_BY = {
    COMPANY: 'displayName',
    LAST_ACTIVE: 'destroyTime'
};

export const SUBAGENTS_SORT_BY = {
    COMPANY: 'companyName',
    LAST_ACTIVE: 'lastActive.status.label'
};

export const USERS_SORT_BY = {
    NAME: 'username',
    LAST_ACTIVE: 'lastActiveDate',
    ROLE: 'role.value.value',
    STATUS: 'lastActive.status.label'
};

export const ORDER_BY = {
    ASC: 'ASC',
    DESC: 'DESC'
};

export const STATUS = {
    CREATED: 'Created',
    SUBAGENT_CREATED: 'Sub-agent created',
    CONFIRMED: 'Confirmed',
    EXPIRED: 'Expired',
    VOIDED: 'Voided',
    VALID: 'Valid'
};

export const DATE_FORMAT = {
    MAINTENANCE: 'dddd, DD MMMM YYYY [at] HH:mmA [GMT+8:00]',
    MAINTENANCE_CHI: 'YYYY年MM月DD日 星期e HH:mmA [GMT+8:00]',
    INSTANT: 'YYYY-MM-DDTHH:mm:ssZ',
    DATE: 'DD MMM YYYY',
    DATETIME: 'DD MMM YYYY HH:mm',
    FILE_DATE: 'YYYYMMDD',
    TIME: 'HH:mm'
};

export const HISTORY_STATUS = {
    CREATED: 'Created',
    CONFIRMED: 'Confirmed',
    UPDATED: 'Updated',
    ISSUED: 'Issued',
    EXPIRED: 'Expired',
    VOIDED: 'Voided'
};

export const CONTACT_TAB = {
    COMPANY: 'COMPANY',
    NORMAL_USER: 'NORMAL_USER',
    API_USER: 'API_USER'
};

export const CONTACT_ACTION = {
    INVITE: 'Invite',
    RESEND_INVITATION: 'Resend Invitation',
    RECALL_INVITATION: 'Recall Invitation',
    DEACTIVATE: 'De-activate',
    RECOVER: 'Recover',
    CHANGE_ROLE: {
        BE_ADMIN: 'grant admin rights to',
        BE_USER: 'remove admin rights from'
    }
};

export const CONTACT_RELEVANT_DATE = {
    INVITED: {
        status: {
            value: 'invited',
            label: 'Pending'
        },
        label: 'Invitation sent on'
    },
    DEACTIVATED: {
        status: {
            value: 'isDisabled',
            label: 'Disabled'
        },
        label: 'De-activated by'
    },
    LAST_LOGGED_IN: {
        status: {
            value: 'isActiveAndNotLocked',
            label: 'Active'
        },
        label: 'Last logged in'
    },
    LOCKED: {
        status: {
            value: 'isActive',
            label: 'Locked'
        },
        label: 'Last logged in'
    }
};

export const SECRET_TYPE = {
    SECRET_KEY: 'Secret Key',
    PASSWORD: 'Password'
};

export const dashboardUnderlined = [
    'dashboard',
    'companies',
    'users'
];

export const stagesWithoutMidasNo = [
    CREATE_FORM_STAGE.CREATE,
    CREATE_FORM_STAGE.CONFIRM_CREATE
];

export const stagesWithoutStatus = [
    CREATE_FORM_STAGE.CREATE,
    CREATE_FORM_STAGE.CONFIRM_CREATE,
    VERIFY_FORM_STAGE.CONVERT_TO_POLICY
];

export const formsWithFormType = [
    FORM_TYPE.IN_CREATE_COVER_NOTE,
    FORM_TYPE.IN_CREATE_POLICY
];

export const stagesEditable = [
    CREATE_FORM_STAGE.CREATE,
    VERIFY_FORM_STAGE.CONVERT_TO_POLICY,
    UPDATE_FORM_STAGE.UPDATE
];

export const stagesCanPrint = [
    CREATE_FORM_STAGE.CREATE_CN_SUMMARY,
    CREATE_FORM_STAGE.CREATE_PY_SUMMARY
];

export const formsCanUpdatePolicy = [
    FORM_TYPE.IN_CREATE_POLICY,
    FORM_TYPE.IN_CONVERT_TO_POLICY
];

export const createForms = [
    FORM_TYPE.SA_CREATE_COVER_NOTE,
    FORM_TYPE.IN_CREATE_COVER_NOTE,
    FORM_TYPE.IN_CREATE_POLICY
];

export const updateForms = [
    FORM_TYPE.UPDATE_COVER_NOTE,
    FORM_TYPE.UPDATE_POLICY
];

export const redirectForms = [
    FORM_TYPE.SA_CREATE_COVER_NOTE,
    FORM_TYPE.IN_CREATE_COVER_NOTE,
    FORM_TYPE.IN_CREATE_POLICY,
    FORM_TYPE.IN_CONVERT_TO_POLICY
];

export const updateStages = [
    UPDATE_FORM_STAGE.UPDATE,
    UPDATE_FORM_STAGE.CONFIRM_VOID,
    UPDATE_FORM_STAGE.CONFIRM_UPDATE
];

export const identityOptions = [
    {value: 'HKID', label: 'Hong Kong Identity Card Number (HKID)'},
    {value: 'CR', label: 'Companies Registry (CR)'},
    {value: 'OTHER', label: 'Other'}
];

export const formTypeOptions = [
    {value: 'COVER_NOTE', label: 'Cover Note'},
    {value: 'POLICY', label: 'Policy'}
];

export const referenceOptions = [
    {value: 'CHASSIS_NUMBER', label: 'Chassis Number'},
    {value: 'MIDAS_NUMBER', label: 'Midas Number'},
    {value: 'ISSUE_NUMBER', label: 'Cover Note Number / Policy Number'}
];

export const itemsToBeChecked = [
    {value: 'policyReference', label: 'Number'},
    {value: 'licensePlateNumber', label: 'License Plate Number'},
    {value: 'policyStartDate', label: 'Start Date'},
    {value: 'policyEndDate', label: 'End Date'},
    {value: 'coverPeriod', label: 'Cover Period'}
];

export const roleOptions = [
    {value: 'USER', label: 'User'},
    {value: 'ADMIN', label: 'Admin'}
];

export const itemsIgnored = ['row', 'coverPeriod', 'errorMsgs'];

export const updateActions = ['NTP', 'UCN', 'UN', 'UP', 'VPN'];

export const secretTypes = ['SECRET_KEY', 'PASSWORD'];

export const DAY_NUMBER = ['日', '一', '二', '三', '四', '五', '六'];

// hard code the urls to track
export const ENABLE_TRACKING = window.location.hostname === "portal-midas.hkfi.org.hk" || window.location.hostname === "midas.hkfi.org.hk";

export const GA_MEASUREMENT_ID = {
    ENQUIRY: "G-Y3G2S0ZSDQ",
    PORTAL: "G-E2H4YJ5RHJ",
};

export const GTM_ID = {
    ENQUIRY: "GTM-N88Z7F8",
    PORTAL: "GTM-TQF2352",
};



// WEBPACK FOOTER //
// ./src/Config/appConfig.ts